module.exports = __webpack_public_path__ + "static/media/sorting.24f61809.png";